import { ProjectViewModel } from "../../ViewModel/ProjectViewModel";

export const getRouteById = (routeId: number, project: ProjectViewModel) => {
  return project.FTLRoutes?.find((route) => route.RouteId === routeId);
};
